import React from 'react';
import { PlanningDocumentCard } from './PlanningDocumentCard';
import { VideoAssetCard } from './VideoAssetCard';
import { DraftAssetCard } from './DraftAssetCard';
import { DEMO_PIPELINE_DRAFT_THUMB, DEMO_PIPELINE_MEDIA_THUMB } from './demoStockImages';

const INSTAGRAM_DRAFT = {
  platformName: 'Instagram',
  platformColor: '#9333ea',
  logoPath: '/platform-logos/instagram-logo.png',
  fallbackIcon: '🎬',
};

/** Pipeline grid cell — real card chrome per deliverable type. */
export function PipelineMiniCard({ rowId, row, stageLabel, stageTone = 'internal' }) {
  const status = (
    <span className={`mkt-pipeline-mini-card-status mkt-pipeline-mini-card-status--${stageTone}`}>
      <strong>{stageLabel}</strong>
    </span>
  );

  if (rowId === 'planning') {
    return (
      <div className="mkt-pipeline-mini-card">
        <PlanningDocumentCard
          title={row.item}
          accentColor={row.color}
          className="mkt-pipeline-mini-card-inner mkt-pipeline-mini-card-inner--planning"
        />
        {status}
      </div>
    );
  }

  if (rowId === 'media') {
    return (
      <div className="mkt-pipeline-mini-card">
        <VideoAssetCard
          title={row.filename ?? 'brand-interview.mp4'}
          duration="2:14"
          thumbnailUrl={DEMO_PIPELINE_MEDIA_THUMB}
          thumbnailLoading="eager"
          showLibraryBadge
          badgeLabel="Media"
          compact
          className="mkt-pipeline-mini-card-inner mkt-pipeline-mini-card-inner--video"
        />
        {status}
      </div>
    );
  }

  return (
    <div className="mkt-pipeline-mini-card">
      <DraftAssetCard
        title={row.filename ?? 'reel-cut.mp4'}
        platformName={INSTAGRAM_DRAFT.platformName}
        platformColor={INSTAGRAM_DRAFT.platformColor}
        logoPath={INSTAGRAM_DRAFT.logoPath}
        fallbackIcon={INSTAGRAM_DRAFT.fallbackIcon}
        thumbnailUrl={DEMO_PIPELINE_DRAFT_THUMB}
        thumbnailLoading="eager"
        className="mkt-pipeline-mini-card-inner mkt-pipeline-mini-card-inner--draft"
      />
      {status}
    </div>
  );
}
